import { useParams } from "react-router-dom";
import { Redirect } from "react-router-dom";

import { useUserProfileContext } from "@/contexts/UserProfileContext";
import {
  CMP_PATIENTS_URL,
  CMP_SIGNIN_URL,
  ERROR_404_URL,
  getCmpUrl,
  WARD_BASE_URL
} from "@/core/urls";
import useAvailableOrganisations from "@/hooks/organisations/useAvailableOrganisations";

import AuthRoute from "./AuthRoute";
import Loading from "./Loading";
import WardViewRoutes from "./wardView";

export default function PatientsViewRedirect() {
  const { patientProfile } = useUserProfileContext();
  const { patientId } = useParams();

  const [availableOrganisations] = useAvailableOrganisations();

  const isGuardian = !!patientProfile?.wards
    ?.map(ward => ward.user.id)
    ?.find(id => patientId == id);

  if (isGuardian) {
    // guardians look at patients at the old url without the organisation id in the url
    return <AuthRoute loginUrl={CMP_SIGNIN_URL} path={WARD_BASE_URL} component={WardViewRoutes} />;
  }

  // Let us find the organisation which contains the patient they want to view
  const organisation = availableOrganisations?.find(org => {
    return !!org.patients
      .map(patient => patient.patientProfile.user.id)
      .find(id => patientId == id);
  });

  if (organisation) {
    // partners look at patients at the new url with the org in it
    return (
      <Redirect
        to={getCmpUrl(CMP_PATIENTS_URL, {
          organisationId: organisation.hashId
        })}
      />
    );
  }

  if (availableOrganisations && patientProfile) {
    return <Redirect to={ERROR_404_URL} />;
  }

  return <Loading />;
}
